// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdResult = objectOf({
  added_user_count: number,
  skipped_user_names: maybe(arrayOf(string)),
});
